export type Theme = {
  id: number;
  title: string;
  max: string;
  min: string;
};

export const PAGE_SIZE = 20;
